module.exports = __webpack_public_path__ + "img/graph-bar-white.5df2d1ea.svg";